import { render, staticRenderFns } from "./goodsspuGroup.vue?vue&type=template&id=031734e5&scoped=true&"
import script from "./goodsspuGroup.vue?vue&type=script&lang=js&"
export * from "./goodsspuGroup.vue?vue&type=script&lang=js&"
import style0 from "./goodsspuGroup.vue?vue&type=style&index=0&id=031734e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031734e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031734e5')) {
      api.createRecord('031734e5', component.options)
    } else {
      api.reload('031734e5', component.options)
    }
    module.hot.accept("./goodsspuGroup.vue?vue&type=template&id=031734e5&scoped=true&", function () {
      api.rerender('031734e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goodsspuGroup/goodsspuGroup.vue"
export default component.exports